import app from './app';
import { saveAs } from 'file-saver';
import { QUOTE_SERVICE_URL, REPORT_SERVICE_URL, REPORTS_SERVICE_URL } from '../../libs/constants';

export const createQuoteSummary = requestData => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "createQuoteSummary"
        }
    };

    await api.post(QUOTE_SERVICE_URL + "/summary", requestData, headerConfig)
        .then(response => {
            if (response.data.quotationId) {
                dispatch({
                    type: "SET_QUOTE_SUMMARY",
                    data: response.data
                });
            }
            else {
                dispatch(app.setAppModal({ type: "error", messageId: "service_error" }));
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
            console.log(error);
        });
};


export const downloadQuoteTemplate = requestData => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    let downloadConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
            "DRS-Fetch-Type": "downloadHPTemplate"
        },
        responseType: "blob"
    };
    await api.post(REPORT_SERVICE_URL + `download/quoteRequest`, null, downloadConfig)
        .then(response => {
            dispatch(app.setLoading(false));
            saveAs(new Blob([response.data]), "QuoteRequest.xlsx");
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
            console.log(error);
        });
};

const getAllQuotes = (searchConfig, userId) => async (dispatch, getState, api) => {
    const url = QUOTE_SERVICE_URL + "/list/" + userId;
    console.log('Search config : ' + JSON.stringify(searchConfig));
    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getAllQuotes"
        }
    };

    dispatch(app.setLoading(true));

    await api.post(url, searchConfig, headerConfig)
        .then(response => {
            if (response.data.quoteViewList) {
                dispatch({
                    type: "SET_QUOTES_LIST",
                    payload: response.data
                });
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            console.log(error);
        });
};

const getAllVendorCTInitialQuotes = (searchConfig, userId) => async (dispatch, getState, api) => {
    const url = QUOTE_SERVICE_URL + "/list/" + userId;
    console.log('Search config : ' + JSON.stringify(searchConfig));
    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getAllVendorCTInitialQuotes"
        }
    };

    dispatch(app.setLoading(true));

    await api.post(url, searchConfig, headerConfig)
        .then(response => {
            if (response.data.quoteViewList) {
                dispatch({
                    type: "SET_VENDOR_CT_INITIAL_QUOTES_LIST",
                    payload: response.data
                });
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            console.log(error);
        });
};

const getCTInitialQuotes = (userId, searchConfig) => async (dispatch, getState, api) => {
    const url = QUOTE_SERVICE_URL + "/list/" + userId;
    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getCTInitialQuotes"
        }
    };

    dispatch(app.setLoading(true));

    await api.post(url, searchConfig, headerConfig)
        .then(response => {
            if (response.data.quoteViewList) {
                dispatch({
                    type: "SET_QUOTES_LIST",
                    payload: response.data
                });
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            console.log(error);
        });
};

const getQuoteDetails = (userId, quoteId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    const url = QUOTE_SERVICE_URL + "/" + userId + "/" + quoteId;
    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getQuoteDetails"
        }
    };

    await api.post(url, {}, headerConfig)
        .then(response => {
            if (response.data) {
                dispatch({
                    type: "SET_QUOTES_DETAILS",
                    payload: response.data
                });
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            console.log(error);
            dispatch(app.setLoading(false));
        });
};

const getAllDCDashboardDeals = (userId) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": "getAllDCDashboardDeals" } };
        const response = await api.post(QUOTE_SERVICE_URL + "/deal/list/directCustomer/" + userId, {}, headerConfig);

        if (response.data) {
            dispatch({ type: "SET_DC_DASHBOARD_DEALS_LIST", payload: response.data });
        }

        dispatch(app.setLoading(false));
    } catch (error) {
        console.log(error);
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const getCTQuotesForDashboard = (userId, orderType) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    const url = QUOTE_SERVICE_URL + "/dashboard/summary/" + userId + "?orderType=" + orderType;
    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getQuotesForDashboard"
        }
    };

    await api.post(url, {}, headerConfig)
        .then(response => {
            if (response.data) {
                dispatch({
                    type: "SET_QUOTES_FOR_CT_DASHBOARD",
                    payload: response.data
                });
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            console.log(error);
        });
};

const getDCQuotesForDashboard = (userId) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": "getQuotesForDCDashboard" } };
        const response = await api.post(QUOTE_SERVICE_URL + "/dashboard/summary/" + userId, {}, headerConfig);

        if (response.data) {
            dispatch({ type: "SET_QUOTES_FOR_DC_DASHBOARD", payload: response.data });
        }

        dispatch(app.setLoading(false));
    } catch (error) {
        console.log(error);
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const getDCQuotesForDashboardByFilter = (userId, filters) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": "getQuotesForDCDashboardByFilter" } };
        const response = await api.post(QUOTE_SERVICE_URL + "/dashboard/directCustomer/summary/" + userId, {...filters}, headerConfig);

        if (response.data) {
            dispatch({ type: "SET_QUOTES_FOR_DC_DASHBOARD", payload: response.data });
        }
    } catch (error) {
        console.log(error);
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const acceptQuote = (userId, quoteId, salesContractId) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": "quoteAccepted" } };
        const response = await api.post(QUOTE_SERVICE_URL + '/directCustomer/acceptQuote/' + userId + '/' + quoteId, { salesContractId: salesContractId }, headerConfig);

        if (response.data) {
            dispatch({ type: "SET_QUOTES_DETAILS", payload: response.data, isQuoteAccepted: true });
        }

        dispatch(app.setLoading(false));
    } catch (error) {
        console.log(error);
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const rejectQuote = (userId, quoteId) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": "quoteRejected" } };
        const response = await api.post(QUOTE_SERVICE_URL + '/directCustomer/rejectQuote/' + userId + '/' + quoteId, {}, headerConfig);

        if (response.data) {
            dispatch({ type: "SET_QUOTES_DETAILS", payload: response.data, isQuoteAccepted: false });
        }

        dispatch(app.setLoading(false));
    } catch (error) {
        console.log(error);
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const downloadQuote = (userId, quoteId) => async (dispatch, getState, api) => {
    let downloadConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
            "DRS-Fetch-Type": "downloadQuote"
        },
        responseType: "blob"
    };
    await api.post(QUOTE_SERVICE_URL + '/download/' + userId + '/' + quoteId, null, downloadConfig)
        .then(response => {
            saveAs(new Blob([response.data]), `customer_quote_${quoteId}.xlsx`);
        })
        .catch(error => {

        });
};

const downloadVendorCtInitialQuote = (userId, quoteId) => async (dispatch, getState, api) => {
    let downloadConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
            "DRS-Fetch-Type": "downloadVendorCTInitialQuote"
        },
        responseType: "blob"
    };
    await api.post(QUOTE_SERVICE_URL + '/download/customerForm/' + userId + '/' + quoteId, null, downloadConfig)
        .then(response => {
            saveAs(new Blob([response.data]), `CTQuote_${quoteId}_VendorVersion.xlsx`);
        });
};

const downloadCustomerForm = (userId, quoteId, status) => async (dispatch, getState, api) => {
    let downloadConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
            "DRS-Fetch-Type": "downloadCustomerForm"
        },
        responseType: "blob"
    };
    let apiSignature;
    if (status === 'ACCEPTED' || status === 'REJECTED' || status === 'VENDOR_PRICES_PROVIDED' || status === 'CONFIRMATION_PENDING' || status === 'Retrieved') {
        apiSignature = '/download/';
    } else {
        apiSignature = '/download/vendorForm/';
    }
    await api.post(QUOTE_SERVICE_URL + apiSignature + userId + '/' + quoteId, null, downloadConfig)
        .then(response => {
            saveAs(new Blob([response.data]), `customer_quote_${quoteId}.xlsx`);
        });
};

const downloadCustomerQuoteFile = (userId, quoteId) => async (dispatch, getState, api) => {
    let downloadConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
            "DRS-Fetch-Type": "downloadCustomerQuoteForm"
        },
        responseType: "blob"
    };

    await api.post(QUOTE_SERVICE_URL + '/download/' + userId + '/' + quoteId, null, downloadConfig)
        .then(response => {
            saveAs(new Blob([response.data]), `customer_quote_${quoteId}.xlsx`);
        });
}

const downloadHPQuoteTemplate = (userId, quoteId) => async (dispatch, getState, api) => {
    let downloadConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
            "DRS-Fetch-Type": "downloadCustomerQuoteForm"
        },
        responseType: "blob"
    };

    await api.post(QUOTE_SERVICE_URL + '/download/downlaodFileByHPForDirectCustomer/' + userId + '/' + quoteId, null, downloadConfig)
        .then(response => {
            saveAs(new Blob([response.data]), `HP_quote_template_${quoteId}.xlsx`);
        });
}

const downloadVendorFile = (userId, quoteId) => async (dispatch, getState, api) => {
    let downloadConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
            "DRS-Fetch-Type": "downloadVendorForm"
        },
        responseType: "blob"
    };

    await api.post(QUOTE_SERVICE_URL + '/download/vendorForm/' + userId + '/' + quoteId, null, downloadConfig)
        .then(response => {
            saveAs(new Blob([response.data]), `vendor_quote_${quoteId}.xlsx`);
        });
}

const downloadCustomerRequestFile = (userId, quoteId) => async (dispatch, getState, api) => {
    let downloadConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
            "DRS-Fetch-Type": "downloadVendorForm"
        },
        responseType: "blob"
    };

    await api.post(QUOTE_SERVICE_URL + '/download/customerRequestForm/' + userId + '/' + quoteId, null, downloadConfig)
        .then(response => {
            saveAs(new Blob([response.data]), `customer_requested_quote_${quoteId}.xlsx`);
        });
}

const uploadVendorQuote = (requestData, userId, quoteId) => async (dispatch, getState, api) => {
    const config = {
        headers: {
            'content-type': 'multipart/form-data',
            "DRS-Fetch-Type": "uploadQuote"
        }
    }

    dispatch(app.setLoading(true));
    await api.post(QUOTE_SERVICE_URL + "/uploadQuote/" + userId + "/" + quoteId, requestData, config)
        .then(response => {
            if (response.data.quoteId) {
                dispatch(updateQuoteField({ name: "quoteId", value: response.data.quoteId }));
                dispatch(updateQuoteField({ name: "fileUploadStatus", value: "success" }));
            }
            else {
                dispatch(updateQuoteField({ name: "quoteId", value: "" }));
                dispatch(updateQuoteField({ name: "fileUploadStatus", value: "error" }));
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(updateQuoteField({ name: "quoteId", value: "" }));
            dispatch(updateQuoteField({ name: "fileUploadStatus", value: "error" }));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
}

const setQuoteId = quoteId => {
    return {
        type: "SET_QUOTE_ID",
        data: quoteId
    }
}

const setFileUploadStatus = status => {
    return {
        type: "SET_FILE_UPLOAD_STATUS",
        data: status
    }
}

const updateQuoteField = fieldData => {
    return {
        type: 'UPDATE_QUOTE_FIELD',
        data: fieldData
    }
}

const getHPMargins = (requestData, userId) => async (dispatch, getState, api) => {
    try {
        const response = await api.post(QUOTE_SERVICE_URL + '/hpmargins/' + userId, requestData);
        if (response.data.costMarginsResponses) {
            const marginData = response.data.costMarginsResponses;
            const marginCombinedData = [
                ...(marginData["payment1.1"] || []),
                ...(marginData["payment1.0"] || [])
            ];

            if (marginData.hasOwnProperty("payment1.1") || marginData.hasOwnProperty("payment1.0")) {
                dispatch({
                    type: "UPDATE_PAYMENT_ONE_POINT_ONE_DEFAULT_MARGINS",
                    data: marginCombinedData
                });
            } else {
                dispatch(resetPaymentOnePointOneDefaultMargins());
            }

            // if (marginData.hasOwnProperty("payment1.0")) {
            //     dispatch({
            //         type: "UPDATE_PAYMENT_ONE_POINT_O_DEFAULT_MARGINS",
            //         data: marginData["payment1.0"]
            //     });
            // }
            // else {
            //     dispatch(resetPaymentOnePointODefaultMargins());
            // }
        }
    }
    catch (error) {
        console.log(error);
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

export const updateQuotation = (requestData, quotationId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));

    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "updateQuotation"
        }
    };

    await api.post(QUOTE_SERVICE_URL + "/updateQuotation/" + quotationId, requestData, headerConfig)
        .then(response => {
            if (response.data.quotationId) {
                dispatch({
                    type: "SET_QUOTE_SUMMARY",
                    data: response.data
                });
            }
            else {
                dispatch(app.setAppModal({ type: "error", messageId: "service_error" }));
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            console.log(error);
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

export const saveQuotation = (requestData, quotationId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));

    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "saveQuotation"
        }
    };

    await api.post(QUOTE_SERVICE_URL, requestData, headerConfig)
        .then(response => {
            if (response.data.quoteId) {
                dispatch({
                    type: "SET_QUOTE_SAVED",
                    data: response.data
                });
            }
            else {
                dispatch(app.setAppModal({ type: "error", messageId: "service_error" }));
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
            console.log(error);
        });
};

const resetPaymentOnePointOneDefaultMargins = () => {
    return {
        type: 'RESET_PAYMENT_ONE_POINT_ONE_DEFAULT_MARGINS',
        data: []
    }
}

const resetPaymentOnePointODefaultMargins = () => {
    return {
        type: 'RESET_PAYMENT_ONE_POINT_O_DEFAULT_MARGINS',
        data: []
    }
}

const updateQuoteGeneralDataField = fieldData => {
    return {
        type: 'SET_CT_INITIAL_QUOTE_DETAIL_FIELD',
        data: fieldData
    }
}

const resetQuoteSummaryData = () => {
    return {
        type: 'RESET_QUOTE_SUMMARY_DATA'
    }
}

const updateCountryList = countryList => {
    return {
        type: 'UPDATE_CT_COUNTRY_LIST',
        data: countryList
    }
}

const updateCTInitalQuoteData = (value, columnName, rowIndex) => {
    return {
        type: 'UPDATE_CT_INITIAL_QUOTE_DATA',
        value,
        columnName,
        rowIndex
    }
}

const restoreQuoteState = (quoteState) => {
    return {
        type: 'RESTORE_QUOTE_STATE',
        quoteState
    }
}

const updateCTInitialQuoteStatusInformation = (updatedCTInitialQuoteStatusData) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": "getUpdatedCTInitialQuoteStatusData" } };
        await api.post(QUOTE_SERVICE_URL + '/updateQuoteStatusData', updatedCTInitialQuoteStatusData, headerConfig);

        dispatch(app.setLoading(false));
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const quoteActions = {
    createQuoteSummary,
    updateQuotation,
    saveQuotation,
    resetQuoteSummaryData,
    getAllQuotes,
    getQuoteDetails,
    acceptQuote,
    rejectQuote,
    downloadQuote,
    uploadVendorQuote,
    setQuoteId,
    setFileUploadStatus,
    updateQuoteField,
    downloadCustomerForm,
    downloadCustomerQuoteFile,
    downloadHPQuoteTemplate,
    downloadVendorFile,
    downloadCustomerRequestFile,
    getCTQuotesForDashboard,
    getDCQuotesForDashboard,
    getDCQuotesForDashboardByFilter,
    getAllDCDashboardDeals,
    getCTInitialQuotes,
    getAllVendorCTInitialQuotes,
    downloadVendorCtInitialQuote,
    getHPMargins,
    resetPaymentOnePointODefaultMargins,
    resetPaymentOnePointOneDefaultMargins,
    updateQuoteGeneralDataField,
    updateCountryList,
    updateCTInitalQuoteData,
    updateCTInitialQuoteStatusInformation,
    restoreQuoteState,
    downloadQuoteTemplate
}

export default quoteActions;
